document.addEventListener('DOMContentLoaded', () => {
    const allAccordions = document.querySelectorAll('.js-accordion');

    allAccordions.forEach(accordion => {
        const questions = accordion.querySelectorAll('.js-accordion-question');

        questions.forEach(question => {
            const answerId = question.getAttribute('aria-controls');
            const answer = document.getElementById(answerId);
            const freeForAll = accordion.classList.contains('free-for-all');

            question.addEventListener('click', () => {
                const isOpen = answer.classList.contains('open');

                // Close all others
                accordion.querySelectorAll('.accordion-answer.open').forEach(other => {
                    if (other !== answer) {
                        other.classList.remove('open');
                        other.style.height = 0;
                        const otherButton = accordion.querySelector(`[aria-controls="${other.id}"]`);
                        if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
                        setTimeout(() => {
                            other.setAttribute('aria-hidden', 'true');
                        }, 550);
                    }
                });

                // Toggle clicked one
                if (isOpen) {
                    if (freeForAll) {
                        answer.classList.remove('open');
                        answer.style.height = 0;
                        question.setAttribute('aria-expanded', 'false');
                        setTimeout(() => {
                            answer.setAttribute('aria-hidden', 'true');
                        }, 550);
                    }
                } else {
                    const inner = answer.querySelector('.inner');
                    if (inner) {
                        const innerHeight = inner.offsetHeight;
                        answer.classList.add('open');
                        answer.style.height = innerHeight + 'px';
                        question.setAttribute('aria-expanded', 'true');
                        setTimeout(() => {
                            answer.setAttribute('aria-hidden', 'false');
                        }, 550);
                    }
                }
            });
        });

        // Ensure one is open if not free-for-all
        if (!accordion.classList.contains('free-for-all')) {
            const opened = accordion.querySelector('.accordion-answer.open');
            if (!opened) {
                const firstQuestion = accordion.querySelector('.js-accordion-question');
                if (firstQuestion) firstQuestion.click();
            }
        }
    });

    window.onresize = () => {
        document.querySelectorAll('.js-accordion .accordion-answer.open').forEach(answer => {
            const inner = answer.querySelector('.inner');
            if (inner) {
                answer.style.height = inner.offsetHeight + 'px';
            }
        });
    };
});
